import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import _ from 'underscore'
import { emptycontent, emptylist } from './empty';

Vue.use(Vuex)
const state = {
  moduleId: "",
  appweb: {},
  match: {},
  gameId: "",
  emptycontent,
  emptylist,
  menuname: "",
}
const getters = {

}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})


// WEBPACK FOOTER //
// ./src/store/index.js